import HeaderSpan from './HeaderSpan'
import SpeedAndDistanceItem from './SpeedAndDistanceItem'
import { langSessionList } from '../assets/langSessionList'
import { useLang } from '../utils/hooks'
import { speedAndDistanceColors } from '../assets/colors'
import { w_speed_and_distance } from '../assets/colors'

const SpeedAndDistanceList = ({
  data,
  filters,
  handleSelectNewItem,
  handleSort,
  textClass,
}) => {
  const background = speedAndDistanceColors.headerCl
  const { lang } = useLang()

  const choosenLang = lang === 'fr' ? langSessionList.fr : langSessionList.eng
  const list = data.list
  const selectedItemId = data.selectedItemId

  const sortOrder = filters.sortOrder.isReverse
  const sortType = filters.sortOrder.sortType

  const handleClickOnItem = (event) => {
    let itemId = event.target.id
    const item = list.filter((session) => itemId === session.id)[0]
    handleSelectNewItem(item)
  }

  const onSort = (columnType) => {
    handleSort(columnType)
  }

  let i = -1

  return (
    <div className={textClass + ' content container-high'}>
      {list.length > 0 ? (
        <>
          <div>
            <table
              className="table is-striped"
              style={{ tableLayout: 'fixed' }}
            >
              <thead>
                <tr>
                  <th
                    className="pl-0"
                    style={{ width: w_speed_and_distance[++i] + '%' }}
                  >
                    <HeaderSpan
                      headerTitle={choosenLang.date}
                      background={background}
                      columnType={'DATE_SORT'}
                      sortType={sortType}
                      sortOrder={sortOrder}
                      handleOnClick={onSort}
                    />
                  </th>
                  <th
                    className="pl-0"
                    style={{ width: w_speed_and_distance[++i] + '%' }}
                  >
                    <HeaderSpan
                      headerTitle={choosenLang.speed}
                      background={background}
                      columnType={'SPEED_SORT'}
                      sortType={sortType}
                      sortOrder={sortOrder}
                      handleOnClick={onSort}
                    />
                  </th>
                  <th
                    className="pl-0"
                    style={{ width: w_speed_and_distance[++i] + '%' }}
                  >
                    <HeaderSpan
                      headerTitle={choosenLang.distance}
                      background={background}
                      columnType={'DISTANCE_SORT'}
                      sortType={sortType}
                      sortOrder={sortOrder}
                      handleOnClick={onSort}
                    />
                  </th>
                  <th
                    className="pl-0"
                    style={{ width: w_speed_and_distance[++i] + '%' }}
                  >
                    <HeaderSpan
                      headerTitle={choosenLang.maxSpeedRig}
                      background={background}
                      columnType={'MAX_SPEED_RIG_SORT'}
                      sortType={sortType}
                      sortOrder={sortOrder}
                      handleOnClick={onSort}
                    />
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div
            className="table-container"
            style={{ maxHeight: 150, overflow: 'scroll' }}
          >
            <table>
              <tbody>
                {list.map((oneSession) => {
                  return (
                    <SpeedAndDistanceItem
                      key={oneSession._id}
                      session={oneSession}
                      onClick={handleClickOnItem}
                      isSelected={oneSession.id === selectedItemId}
                    ></SpeedAndDistanceItem>
                  )
                })}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="notification is-warning is-light is-notif">
          {choosenLang.noSessions}
        </div>
      )}
    </div>
  )
}

export default SpeedAndDistanceList
